import React from 'react';

import { useField } from 'formik';

import FormControl from '@material-ui/core/FormControl';
import FormHelperText from '@material-ui/core/FormHelperText';
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';
import InputLabel from '@material-ui/core/InputLabel';

const SelectInput = ({ label, ...props }) => {
    const [field, meta] = useField(props);

    return (
        <FormControl fullWidth error={meta.touched && meta.error && meta.error.length > 0}>
            <InputLabel>{label}</InputLabel>
            <Select {...field} {...props}>
                {props.options.map(option => {
                    return <MenuItem key={option.value} value={option.value}>{option.label}</MenuItem>;
                })}
            </Select>

            {meta.touched && meta.error ? (
                <FormHelperText>{meta.error}</FormHelperText>
            ) : null}
        </FormControl>
    )
}

export default SelectInput;